import React from 'react';
import { Pie } from '@ant-design/plots';
import { Typography, Space } from 'antd';

const { Text } = Typography;

const DonutChart = ({ data }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  // Find “Utilized” value
  const utilizedData = data.find((item) => item.type === 'Utilized');
  const utilizedData1 = data.find((item) => item.type === 'Remaining');

  const utilizedPercent = utilizedData
    ? ((utilizedData.value / total) * 100).toFixed(1)
    : '0.0';

  const utilizedPercent1 = utilizedData1
    ? ((utilizedData1.value / total) * 100).toFixed(1)
    : '0.0';


  // const colorMap = {
  //   Utilized: 'rgb(87, 209, 195)',
  //   Remaining: 'rgba(65, 116, 110, 1)',
  // };


  const colorMap = {
    Utilized: 'rgb(87, 209, 195)',
    Remaining: 'rgba(65, 116, 110, 1)',
  };

  // const config = {
  //   data,
  //   angleField: 'value',
  //   colorField: 'type',
  //   radius: 1,
  //   innerRadius: 0.7,
  //   height: 250,
  //   width: 250,
  //   color: ({ type }) => colorMap[type] || '#ccc',
  //   legend: false,
  //   statistic: {
  //     title: false,
  //     content: {
  //       style: {
  //         fontSize: '24px',
  //         fontWeight: 'bold',
  //         lineHeight: '1',
  //       },
  //       formatter: () => `${utilizedPercent}%`,
  //     },
  //   },
  // };

  const config = {
    data,
    angleField: 'value',
    colorField: 'type',
    radius: 1,
    innerRadius: 0.7,
    height: 250,
    // width: 250,
    // color: ['#8c8c8c'],
    // HARD OVERRIDE COLORS

    scale: {
      color: {
        domain: ['Remaining', 'Utilized'],
        range: ['rgba(65, 116, 110, 1)', 'rgb(87, 209, 195)'],
      },
    },

    // scale: {
    //   color: {
    //     range: ['rgba(65, 116, 110, 1)', 'rgba(65, 116, 110, 1)'],
    //   },
    // },
    legend: false,
    tooltip: {
      items: [
        (datum) => ({
          name: datum.type,
          value: formatCurrency(datum.value),
        }),
      ],
    },
    statistic: {
      title: false,
      content: {
        style: {
          fontSize: '24px',
          fontWeight: 'bold',
          lineHeight: '1',
        },
        // formatter: () => `${utilizedPercent}%`,
        formatter: () => (
          <div className="lh-chart-text">
            <div className="lh-chart-percent">{utilizedPercent1}%</div>
            <div className="lh-chart-sub">Remaining</div>
          </div>
        )
      },
    },
    annotations: [
      {
        type: 'text',
        style: {
          text: utilizedPercent1 + '% \n Remaining',
          x: '50%',
          y: '50%',
          textAlign: 'center',
          fontSize: 14,
          fill: '#f4f4f5b3',
        },
      }
    ]
  };

  const formatCurrency = (value) => {
    const formatted = value?.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }) || '';

    // Insert a space after the dollar sign
    return formatted.replace('$', '$ ');
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <Pie {...config} />

      <Space
        direction="vertical"
        size={8}
        style={{ marginTop: 24, textAlign: 'center' }}
      >
        {data.map((item) => {
          const percent =
            total > 0
              ? ((item.value / total) * 100).toFixed(1)
              : '0.0';

          return (
            <>
              <div key={item.type}>
                <Space>
                  <span
                    style={{
                      display: 'inline-block',
                      width: 12,
                      height: 12,
                      borderRadius: 2,
                      backgroundColor: colorMap[item.type],
                    }}
                  />
                  <Text>
                    {item.type}:
                  </Text>
                  <Text strong>
                    {percent} %, {formatCurrency(item.value)}
                  </Text>
                </Space>
              </div>
            </>
          );
        })}
      </Space>
    </div>
  );
};

export default DonutChart;